export default __webpack_public_path__ + "perl.f4f41775.png";